import base from "../baseurl";
import token from "../getTk";

const showAll = async (Uuid, type) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log("El uuid de envio y tipo", Uuid, type);
  const Create = await api
    .post("election/showall", {
      json: {
        status: [type],
        companyUuid: Uuid,
      },
    })
    .json();
  return Create;
};

export default showAll;
